import { render } from "./b-table.vue?vue&type=template&id=d06ff4b8&scoped=true"
import script from "./b-table.vue?vue&type=script&lang=js"
export * from "./b-table.vue?vue&type=script&lang=js"

import "./b-table.vue?vue&type=style&index=0&id=d06ff4b8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\FrankCastelijns\\bzx_status\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d06ff4b8"]])

export default __exports__